import React from 'react';
import { ReactComponent as Icon } from '../../assets/images/icons/files-icon.svg';

export default function FilesIcon(props) {
  return (
    <Icon className={`icon ${props.className}`} />
  );
}
